import { render } from "./IconCellRenderer.vue?vue&type=template&id=674b3d22"
import script from "./IconCellRenderer.vue?vue&type=script&lang=js"
export * from "./IconCellRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__